import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default () => {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess(d) {
        setNumPages(d.numPages);
    }

    const pages = new Array(numPages);

    return (
        <Document
            file="https://api-myharmonize-com.s3.amazonaws.com/documents/Harmonize+User+Guide+(Updated+May+2021).pdf"
            onLoadSuccess={onDocumentLoadSuccess}
        >
            {Array.from(
                new Array(numPages),
                (el, index) => (
                    <Page
                        key={`page_${index + 1}`}
                        pageNumber={index + 1}
                    />
                ),
            )}
        </Document>
    );
}




// WEBPACK FOOTER //
// ./src/client/dashboard/Help.tsx